import React from 'react';
import PageShell from './PageShell';
import Breadcrumbs from '../Breadcrumbs';
import Schedule from '../sections/Schedule';
import MidCTA from '../sections/MidCTA';
import { AlertTriangle } from 'lucide-react';
import { usePageMeta } from '../../lib/useMeta';

const PATH = '/schedule';

const BREADCRUMBS = [
  { label: 'Home', href: '/' },
  { label: 'Class Schedule' },
];

const SchedulePage = () => {
  usePageMeta({
    title: 'Class Schedule | Universal Kempo Karate \u2014 Colorado Springs',
    description:
      'Current Kempo karate class schedule for Little Dragons, Kids, Teens, and Adults at our Colorado Springs Revolution location. Tuesday and Thursday evenings.',
    path: PATH,
    breadcrumbs: BREADCRUMBS,
  });
  return (
    <PageShell>
      <Breadcrumbs items={BREADCRUMBS} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 pt-6 pb-4">
        <h1 className="font-display font-black tracking-tight text-white text-[2rem] leading-[1.05] sm:text-5xl sm:leading-[1.02]">
          Class Schedule
        </h1>
        <p className="mt-4 text-white/75 text-[15px] sm:text-lg leading-relaxed max-w-3xl">
          Classes meet Tuesday and Thursday evenings at our Revolution location in northeast
          Colorado Springs. We will match you to the ideal class during your free trial.
        </p>
        <div className="mt-5 panel rounded-xl p-4 flex items-start gap-3" data-testid="schedule-confirm-note">
          <AlertTriangle className="h-5 w-5 text-[color:var(--neon-red)] mt-0.5 shrink-0" />
          <p className="text-xs sm:text-sm text-white/70 leading-relaxed">
            Owner note: specific teen and adult class times below reflect our typical weekly
            schedule but should be confirmed by phone before your first visit — class times
            occasionally shift. Call (719) 896-0593 or book a free trial and we will confirm
            the exact time that fits.
          </p>
        </div>
      </div>
      <Schedule />
      <MidCTA />
    </PageShell>
  );
};

export default SchedulePage;
